/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useVariable from "../../hooks/useVariable";
import ModalAdd from "./Modals/ModalAdd";
import DataTable from "../../components/DataTable/DataTable";
import Title from "../../components/Form/Title";
import ReadOnlyNote from "../../components/Form/ReadOnlyNote";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";

const currency = (value) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(
    Number(value) || 0
  );

export default function Index() {
  const { token, cliente_id, user_rol } = useLogin();
  const dispatch = useDispatch();
  const { loading, message, success, Variables, VariableGetService, VariableDeleteService } = useVariable();
  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [Nombre, setNombre] = useState("");
  const [Numeracion, setNumeracion] = useState("");
  const canManage = user_rol === "super administrador" || user_rol === "cliente";

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setNombre("");
    setNumeracion("");
  };

  useEffect(() => {
    dispatch(setTitle("Descargando variables"));
    dispatch(showLoader());
    if (user_rol === "super administrador") {
      VariableGetService(0, token);
    } else {
      VariableGetService(cliente_id, token);
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (Variables.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => {};
  }, [Variables]);

  useEffect(() => {
    if (success === true) {
      if (user_rol === "super administrador") {
        VariableGetService(0, token);
      } else {
        VariableGetService(cliente_id, token);
      }
    }
  }, [VariableGetService, success]);

  const Eliminar = (e) => {
    const data = new FormData();
    data.append("id", e);
    VariableDeleteService(data, token);

    Swal.fire({
      title: "Espere por favor...",
      text: "Cargando...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      icon: "question",
      onOpen: () => {
        Swal.showLoading();
      },
    });
  };

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  const columns = [];

  if (user_rol === "super administrador") {
    columns.push({ field: "nombre_comercial", title: "Cliente" });
  }

  columns.push(
    { field: "nombre", title: "Nombre" },
    {
      field: "cantidad",
      title: "Monto",
      render: (row) => currency(row.cantidad),
    }
  );

  if (canManage) {
    columns.push({
      field: "Acciones",
      title: "Acciones",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <div className="crud-actions">
          <button
            className="crud-icon-btn edit"
            title="Editar"
            onClick={() => {
              setId(row.id);
              setNombre(row.nombre);
              setNumeracion(row.cantidad);
              setUpdate(true);
              setModal(true);
            }}
          >
            <i className="bi bi-pencil"></i> Editar
          </button>
          <button
            className="crud-icon-btn delete"
            title="Eliminar"
            onClick={() => {
              Eliminar(row.id);
            }}
          >
            <i className="bi bi-trash"></i> Eliminar
          </button>
        </div>
      ),
    });
  }

  return (
    <>
      <ModalAdd
        modal={modal}
        toggle={toggle}
        Nombre={Nombre}
        Numeracion={Numeracion}
        Update={Update}
        Id={Id}
        token={token}
        setNombre={setNombre}
        setNumeracion={setNumeracion}
        VariableGetService={VariableGetService}
        cliente_id={cliente_id}
      />
      <div className="container">
        <div className="crud-header">
          <Title title="Listado de Variables" className="crud-title" />
          {canManage ? (
            <button className="crud-add-btn" onClick={toggle}>
              <i className="bi bi-plus-lg"></i>
              Agregar variable
            </button>
          ) : (
            <ReadOnlyNote />
          )}
        </div>
        <div className="crud-card">
          <DataTable tableKey="variables" loading={loading} columns={columns} data={Variables} />
        </div>
      </div>
    </>
  );
}
